import permissions from '../permissions'

const TITULAR_TICKET_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.TITULAR_TICKETS.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.INTERACT,
    tag: permissions.TITULAR_TICKETS.INTERACT,
  },
  {
    name: 'Gerenciar configurações',
    tag: permissions.TITULAR_TICKETS.MANAGE_CONFIGURATIONS,
  },
]

export default TITULAR_TICKET_LIST
